import Widget, { registerModuleClass } from '@sparta.global.utilities/sparta-widget-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { startsWith } from '@sparta.global.helpers/strings-helper/dist/es6.js';

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,"head-row","==",(depth0 != null ? lookupProperty(depth0,"position") : depth0),{"name":"compare","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":14,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,"head-sub-row","==",(depth0 != null ? lookupProperty(depth0,"position") : depth0),{"name":"compare","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":4},"end":{"line":26,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"startsWith")||(depth0 && lookupProperty(depth0,"startsWith"))||alias2).call(alias1,"dynamic-row",(depth0 != null ? lookupProperty(depth0,"position") : depth0),{"name":"startsWith","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":4},"end":{"line":38,"column":19}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,"foot-row","==",(depth0 != null ? lookupProperty(depth0,"position") : depth0),{"name":"compare","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":4},"end":{"line":50,"column":16}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <section id=\"head-row\" class=\"small-centered head-row\""
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"data-magellan-fixed") : stack1),"==","true",{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":60},"end":{"line":4,"column":161}}})) != null ? stack1 : "")
    + ">\n        <div class=\"row spa-collapse-small spa-uncollapse-large\">\n          <div class=\"large-12 columns\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"module") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":14},"end":{"line":10,"column":23}}})) != null ? stack1 : "")
    + "          </div>\n        </div>\n      </section>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return " data-magellan-expedition=\"fixed\"";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"renderedHTML") : depth0), depth0)) != null ? stack1 : "")
    + "\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <section class=\"small-centered "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"sectionClass") : depth0), depth0))
    + " "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"options") : depth0)) != null ? lookupProperty(stack1,"sectionClass") : stack1), depth0))
    + "\""
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(alias3,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"data-magellan-fixed") : stack1),"==","true",{"name":"compare","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":89},"end":{"line":28,"column":209}}})) != null ? stack1 : "")
    + ">\n        <div class=\"row spa-collapse-small spa-uncollapse-large\">\n          <div class=\"large-12 columns\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"module") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":14},"end":{"line":34,"column":23}}})) != null ? stack1 : "")
    + "          </div>\n        </div>\n      </section>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " data-magellan-destination=\""
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"sectionClass") : depth0), depth0)) != null ? stack1 : "")
    + "\"";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <section class=\"small-centered foot-row\">\n        <div class=\"row spa-collapse-small spa-uncollapse-large\">\n          <div class=\"large-12 columns\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"module") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":44,"column":14},"end":{"line":46,"column":23}}})) != null ? stack1 : "")
    + "          </div>\n        </div>\n      </section>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-component=\"layout\" data-layout=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"name") : stack1), depth0))
    + "\" data-version=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"layoutVersion") : stack1), depth0))
    + "\" class=\"sparta-layout layout-1col-multi-row\" id=\"top\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"sections") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":51,"column":11}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  return Template$1(data, options);
};

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global-tenants.widgets/gt-footer-unauth-secure-bofa-widget",
  "version": "1.0.0",
  "id": "globalTenantsGtFooterUnauthSecureBofaWidget",
  "containerID": "globalTenantsGtFooterUnauthSecureBofaWidget",
  "moduleName": "gt-footer-unauth-secure-bofa-widget",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "gt-footer-unauth-secure-bofa-widget",
  "data": {
    "init": "GtFooterUnauthSecureBofaWidget"
  },
  "moduleParams": [],
  "layout": renderTemplate$1,
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        compare,
        startsWith
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    compare,
    startsWith
  },
  "dependencies": {
    "@sparta.global.templates/link-template": "^1.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/strings-helper": "^1.0.0",
    "@sparta.global.templates/footnote-suplink": "^1.0.0",
    "@sparta.global.templates/glossary-link": "^1.0.0",
    "@sparta.global.templates/glossary-terms": "^1.0.0",
    "@sparta.global.templates/render-module-template": "^1.0.0",
    "@sparta.global.templates/widget-layout-support-footer": "^1.0.0",
    "@sparta.global.templates/widget-layout-support-header": "^1.0.0",
    "@sparta.global.utilities/sparta-bootstrap-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-widget-utility": "^1.0.0",
    "@sparta.global-tenants.modules/gt-footer-unauth-secure-bofa-module": "^1.0.0",
    "@sparta.global.modules/global-social-module": "^1.0.0"
  }
};

/**
 * Widgets Global Tenants Footer Unauth Secure Bank of America Widget
 * @author DG Griffins <dg.griffins@bofa.com>
 *
 *
 *
 * 
 * 
 */

/**
 * Global Tenants Footer Unauththenticated Secure Bank of America Widget
 * 
 * 
 * 
 * 
 * @extends Widget
 * @class
 */
class GtFooterUnauthSecureBofaWidget extends Widget {
  /**
   * Constructor
   * 
   * 
   * 
   *
   * @param {object} options
   * @param {object} context
   * @memberof Widget
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }
}
registerModuleClass({
  moduleClass: GtFooterUnauthSecureBofaWidget,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { GtFooterUnauthSecureBofaWidget as default, moduleConfig };
